'use strict'

const clone = value => JSON.parse(JSON.stringify(value))

module.exports = clone
